import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
// import { LockGameComponent } from "./components/LockComponent";
import { HintComponent } from "./components/HintComponent";
import { ModalMiniGameComponent } from "./components/ModalMiniGameComponent";

// Expose the web components to the browser
window.customElements.define("game-hint", HintComponent);
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
// window.customElements.define("game-lock-keypad", LockGameComponent);
window.customElements.define("game-modalminigame", ModalMiniGameComponent);
